
import {fragments} from "@Common/react/fragments";

import {groupEnrollmentEditors} from "../../../../../common/group-enrollment-editors";
import {
    enrollmentEditor,
    ui
}                               from "../../common/expo-types";

import {ScMailingUnaddressedCopiesQuantityLogic} from "./sc-mailing-unaddressed-copies-quantity-logic";
import {UnaddressedCopiesUi}                     from "./ui/unaddressed-copies-ui";
import {UnaddressedCopiesLogic}                  from "./unaddressed-copies-logic";

export const UnaddressedCopiesModules = ({initEnrollment}) => [
    {
        name: "unaddressedCopiesLogic",
        load: ({method}, next) => UnaddressedCopiesLogic({
            initEnrollment,
            enabled: method === "mailing",
            next,
        }),
        expo: [enrollmentEditor],
        requires: ["method"],
    },
    {
        name: "unaddressedCopiesQuantityLogic1",
        load: ({method, unaddressedCopiesLogic}, next) => ScMailingUnaddressedCopiesQuantityLogic({
            initEnrollment,
            enabled: method === "mailing" && unaddressedCopiesLogic?.state.value,
            next,
        }),
        requires: ["method", "unaddressedCopiesLogic"],
    },
    {
        name: "unaddressedCopiesQuantityLogic2",
        load: ({unaddressedCopiesQuantityLogic1, shippingPaperPrices, shippingPaperPrice}, next) => unaddressedCopiesQuantityLogic1.renderStep2({
            paperPrices: shippingPaperPrices,
            paperPrice: shippingPaperPrice,
            next,
        }),
        expo: [enrollmentEditor],
        requires: ["unaddressedCopiesQuantityLogic1", "shippingPaperPrices", "shippingPaperPrice"],
    },
    {
        load: ({unaddressedCopiesLogic, unaddressedCopiesQuantityLogic2, shippingAddress1, shippingServiceLevel1}, next) => next(unaddressedCopiesLogic && {
            enrollmentEditor: unaddressedCopiesLogic.state.value && groupEnrollmentEditors([
                shippingAddress1.enrollmentEditor,
                shippingServiceLevel1.enrollmentEditor,
            ]) || null,
            ui: ({showErrors}) => UnaddressedCopiesUi({
                enabled: unaddressedCopiesLogic.state,
                quantityUi: unaddressedCopiesQuantityLogic2.ui({showErrors}),
                renderAddressSection: () => fragments(
                    shippingAddress1.render({showErrors}),
                    shippingServiceLevel1.render({showErrors}),
                ),
            }),
        }),
        requires: ["unaddressedCopiesLogic", "unaddressedCopiesQuantityLogic2", "shippingAddress1", "shippingServiceLevel1"],
        expo: [ui(2, {hasSpacer: true}), enrollmentEditor],
    },
];
